/**
 * Public website origins, single host, path surfaces.
 */
export const SITE_ORIGIN = 'https://www.getbyonco.com';
export const APP_ORIGIN = 'https://www.getbyonco.com/app';
export const TALK_ORIGIN = 'https://www.getbyonco.com/talk';
export const SITE_URL = SITE_ORIGIN;
export const SUPPORT_EMAIL = 'care@getbyonco.com';

export function absoluteUrl(path = '/') {
  if (!path || path === '/') return `${SITE_ORIGIN}/`;
  if (/^https?:\/\//i.test(path)) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${normalized}`;
}
